import { availableCountries, CountryDetail } from "Models/Enums/CountryCodeEnum";
import ComboboxSetter from "../Combobox/ComboboxSetter"

type Props = {
	value?: CountryDetail;
	updateValue: (data: CountryDetail) => void;
}

export const CountrySearchBox: React.FunctionComponent<Props> = ({
	value,
	updateValue
}) => {
	const listCountries = availableCountries.map(item => ({
		value: item.code,
		display: item.name
	}))
	
	return (
		<ComboboxSetter
			value={value?.code}
			setValue={newValue => {
				updateValue(availableCountries.find(item => item.code === newValue) || availableCountries[0]);
			}}
			options={listCountries}
			placeholder={"Select a country"}
			label="Search Country"
			getOptionValue={data => data}
		/>
	)
}